import AddIcon from '@mui/icons-material/Add';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import { Fragment } from 'react';
import FieldNames from '../../../defaults/FieldNames.json';
import { getSaveableDate } from '../../../utils/DateHelper';
import DetailsInteragencyText from './DetailsInteragencyText';

const BlueAlien = '#1976d2';

export default function DetailsInteragency({
    detail,
    fieldInfo,
    field,
    onFieldChange,
    allFields,
    interagencySelected,
    setInteragencySelected,
    otherInteragencySelected,
    setOtherInteragencySelected,
    itemsToDelete,
    setItemsToDelete,
    userInfo,
    isDisabled = false,
}) {
    const checkboxChanged = (event, val) => {
        if (event.target.checked) {
            let clone = [];
            if (interagencySelected) {
                clone = [...interagencySelected];
            }
            if (val) {
                clone.push({
                    CreatedBy: userInfo[FieldNames.userFields.nifcUsername],
                    CreatedOnDate: getSaveableDate(new Date()),
                    ID: null,
                    InteragencyName: val.code,
                    JoinFeature: detail?.attributes?.[FieldNames.featureFields.joinFeature] || null,
                    JoinID: detail?.attributes?.[FieldNames.featureFields.joinID] || null,
                    LastModifiedBy: userInfo[FieldNames.userFields.nifcUsername],
                    LastModifiedDate: getSaveableDate(new Date()),
                    OBJECTID: null,
                });
            }
            setInteragencySelected(clone);
            if (val.name === FieldNames.interagencyValues.other) {
                setOtherInteragencySelected([
                    {
                        index: otherInteragencySelected?.length,
                        CreatedBy: userInfo[FieldNames.userFields.nifcUsername],
                        CreatedOnDate: getSaveableDate(new Date()),
                        ID: null,
                        InteragencyName: '',
                        JoinFeature:
                            detail?.attributes?.[FieldNames.featureFields.joinFeature] || null,
                        JoinID: detail?.attributes?.[FieldNames.featureFields.joinID] || null,
                        LastModifiedBy: userInfo[FieldNames.userFields.nifcUsername],
                        LastModifiedDate: getSaveableDate(new Date()),
                        OBJECTID: null,
                    },
                ]);
            }
        } else {
            const interagencyNames = interagencySelected?.map(
                (item) => item[FieldNames.interagencyFields.interagencyName]
            );
            if (interagencyNames && val && interagencyNames?.includes(val.name)) {
                const clone = [...interagencySelected];
                const deleteSelected = itemsToDelete?.length ? [...itemsToDelete] : [];
                let deletedItems = [];
                if (val?.name) {
                    deletedItems = clone.filter(
                        (item) => item[FieldNames.interagencyFields.interagencyName] === val.name
                    );
                    deleteSelected.push(deletedItems);
                    clone.splice(clone.indexOf(val.name), 1);
                }
                setInteragencySelected(clone);
                // The other checkbox is being toggled off, clear all previous values that aren't the default ones.
                if (val?.name === FieldNames.interagencyValues.other) {
                    const defaultCheckboxValues = fieldInfo?.domain?.codedValues?.map(
                        (item) => item.name
                    );
                    const otherInteragencyItemsToRemove = otherInteragencySelected?.filter(
                        (item) =>
                            !defaultCheckboxValues.includes(
                                item[FieldNames.interagencyFields.interagencyName]
                            )
                    );
                    deletedItems.push(otherInteragencyItemsToRemove);
                    setOtherInteragencySelected([]);
                }
                setItemsToDelete(deletedItems?.flat());
            }
        }
    };

    const addNewOtherInteragency = (event) => {
        let clone = [];
        if (otherInteragencySelected?.length) {
            clone = [...otherInteragencySelected];
        }
        clone.push({
            index: otherInteragencySelected?.length,
            CreatedBy: userInfo[FieldNames.userFields.nifcUsername],
            CreatedOnDate: getSaveableDate(new Date()),
            ID: null,
            InteragencyName: '',
            JoinFeature: detail?.attributes?.[FieldNames.featureFields.joinFeature] || null,
            JoinID: detail?.attributes?.[FieldNames.featureFields.joinID] || null,
            LastModifiedBy: userInfo[FieldNames.userFields.nifcUsername],
            LastModifiedDate: getSaveableDate(new Date()),
            OBJECTID: null,
        });
        setOtherInteragencySelected(clone);
    };

    const interagencyNames = interagencySelected?.map((item) => {
        return item[FieldNames.interagencyFields.interagencyName];
    });

    const otherInteragencyNames = otherInteragencySelected?.map((item) => {
        return item[FieldNames.interagencyFields.interagencyName];
    });

    return (
        <FormControl variant='standard'>
            {fieldInfo?.domain?.codedValues?.map((field, i) => (
                <Fragment key={i}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                style={{
                                    padding: '0',
                                    margin: '0 5px 0 0px',
                                    borderColor: BlueAlien,
                                }}
                                id={i}
                                key={i}
                                disabled={isDisabled}
                                checked={interagencyNames?.includes(field?.name) ? true : false}
                                onClick={(e) => checkboxChanged(e, field)}
                            />
                        }
                        label={`${field.name}`}
                    />
                </Fragment>
            ))}

            {interagencyNames?.includes(FieldNames.interagencyValues.other) &&
                otherInteragencyNames?.length > 0 && (
                    <Fragment>
                        {otherInteragencySelected?.map((e, i) => (
                            <DetailsInteragencyText
                                key={i}
                                id={`${i}`}
                                item={
                                    otherInteragencySelected?.[i]?.InteragencyName
                                        ? otherInteragencySelected[i].InteragencyName?.replace(
                                              FieldNames.interagencyValues.otherShortened,
                                              ''
                                          )
                                        : ''
                                }
                                field={field}
                                otherInteragencySelected={otherInteragencySelected}
                                setOtherInteragencySelected={setOtherInteragencySelected}
                                geoID={
                                    detail?.attributes?.[FieldNames.featureFields.joinID] || null
                                }
                                geoType={
                                    detail?.attributes?.[FieldNames.featureFields.joinFeature] ||
                                    null
                                }
                                userInfo={userInfo}
                                isDisabled={isDisabled}
                            />
                        ))}
                        {!isDisabled && (
                            <AddIcon
                                alt='Add another agency'
                                onClick={() => {
                                    addNewOtherInteragency();
                                }}
                            />
                        )}
                    </Fragment>
                )}
        </FormControl>
    );
}
